// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'arrow-down-between-right-column';

export const Component = () => (
  <path d='M16.188 11.973 11.59 7.376l.67-.719 3.449 3.448V0h.957v10.105l3.449-3.448.67.719-4.598 4.597ZM.957 23.52h7.854V13.175h1.006V23.52h13.745V5.847h.958v18.63H0V5.847h.958V23.52Z' />
);

export const viewBox = '0 0 25 25';
